"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpService = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const fetchTransport_1 = require("./fetchTransport");
const HttpURL_1 = require("./HttpURL");
const types_1 = require("./types");
// TODO: ResponseParser
// TODO: ERROR ResponseParser
// TODO: Headers
// TODO: more config, credentials mode and etc
// TODO: Errors
// TODO: tokenManager
// TODO: set token manager and transport
// TODO: refactoring transport to class
class HttpService {
    constructor(config) {
        this.execute = ((payload) => {
            var _a, _b;
            const headers = {};
            const body = (_a = this.config.body) === null || _a === void 0 ? void 0 : _a.encode(payload);
            if (body) {
                headers['Content-Type'] = (_b = this.config.body) === null || _b === void 0 ? void 0 : _b.getType();
            }
            return (0, rxjs_1.from)(this.transport({
                url: this.getUrl(payload),
                method: this.config.method || types_1.HTTP_METHOD.GET,
                headers: headers,
                credentials: types_1.HTTP_CREDENTIALS.OMIT,
                mode: types_1.HTTP_CORS_MODE.CORS,
                body: body
            })).pipe((0, operators_1.map)((res) => {
                return {
                    status: res.status,
                    response: res.body
                };
            }));
        });
        const defaultConfig = {
            method: types_1.HTTP_METHOD.GET
            // isErrorResponse: defaultIsErrorResponse
        };
        this.config = Object.assign(Object.assign({}, defaultConfig), config);
        this.transport = config.transport || fetchTransport_1.fetchTransport;
    }
    getUrl(payload) {
        const baseUrl = this.config.url.toString(payload);
        if (!this.config.query) {
            return baseUrl;
        }
        const queryList = Array.isArray(this.config.query)
            ? this.config.query
            : [this.config.query];
        const query = queryList
            .filter(Boolean)
            .map((i) => i.toString(payload))
            .join('&');
        return `${baseUrl}?${query.replace(/^\?+/, '')}`;
    }
}
exports.HttpService = HttpService;
HttpService.URL = HttpURL_1.HttpURL;
//# sourceMappingURL=HttpService.js.map